<template>
  <v-dialog v-model="dialog" persistent max-width="600px" content-class="bra-20">
    <v-card style="border: 1px solid #fff" class="dialog-notificao-produto">

      <v-card-title class="py-4">
        <slot name="titulo">
          <span>{{ tituloRelatorio }}</span>

          <v-spacer />

          <v-btn icon @click="fecharDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </slot>
      </v-card-title>

      <v-divider />

      <v-card-text class="mt-6">
        <v-row>
          <v-col cols="12" v-if="habilitaFiltro.grupo">
            <v-select
              v-model="filtros.grupo"
              :items="selects.grupo.items"
              label="Selecione o Grupo"
              item-text="descricao"
              item-value="id"
              height="10"
              outlined
              chips
              @change="
                buscarFornecedores();
                buscarFiliais();
                buscarCompradoresPercepcaoCompras();
              "
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" v-if="habilitaFiltro.filial">
            <v-select
              v-model="filtros.filial"
              :items="selects.filial.items"
              label="Selecione a Filial"
              item-value="filial"
              item-text="descricao"
              height="10"
              outlined
              chips
              hide-details
            ></v-select>
          </v-col>

          <v-col cols="12" v-if="habilitaFiltro.filiais">
            <SysFilialGrupoAutocomplete
              v-model="filtros.filial"
              label="Filial"
              outlined
              hide-details
              multiple
              :id-grupo="filtros.grupo"
            />
          </v-col>

          <v-col cols="12" v-if="habilitaFiltro.produtos">
            <sys-produto-autocomplete
              v-model="filtros.idproduto"
              outlined
              label="Selecione o Produto"
              height="10"
              hide-details
              :error-messages="produtoErrors"
            >
            </sys-produto-autocomplete>
          </v-col>

          <v-col cols="12" v-if="habilitaFiltro.usuario">
            <SysUsuariosAutocomplete
              v-model="filtros.usuarios"
              label="Selecione Comprador"
              outlined
              hide-details
              multiple
              :qtde-visivel-selecionados="3"
              clearable
              hide-loading
            />
          </v-col>
          <v-col cols="12" v-if="habilitaFiltro.compradorMult">
            <v-autocomplete
              v-model="filtros.comprador"
              :items="selects.comprador.items"
              label="Selecione o Comprador"
              item-text="nome_completo"
              item-value="idcomprador"
              outlined
              small-chips
              multiple
              hide-details
              class="mtm-30"
              @change="verificaMultiplaSelecaoDeCompradores"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="habilitaFiltro.segmentoMult">
            <v-autocomplete
              v-model="filtros.segmento"
              :items="selects.segmento.items"
              label="Selecione o Segmento"
              item-text="descricao_departamento"
              item-value="iddepartamento"
              outlined
              small-chips
              multiple
              hide-details
              class="mtm-30"
              @change="verificaMultiplaSelecaoDeSegmentos(); buscarFornecedorPorSegmento();"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="habilitaFiltro.departamento">
            <v-autocomplete
              v-model="filtros.departamento"
              :items="selects.departamento.items"
              label="Selecione a departamento"
              item-text="descricao_departamento"
              item-value="iddepartamento"
              small-chips
              multiple
              outlined
              hide-details
              @change="verificaMultiplaSelecaoDeDepartamentos();"
              @blur="buscarSelectMenu(false, true, true, true);"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="habilitaFiltro.fornecedorMult">
            <v-autocomplete
              v-model="filtros.fornecedor"
              :items="selects.fornecedor.items"
              label="Selecione o Fornecedor"
              item-text="razao_social"
              item-value="idfornecedor"
              outlined
              small-chips
              multiple
              hide-details
              @change="verificaMultiplaSelecaoDeFornecedores();"
              @blur="buscarSelectMenu(false, false, true, true);"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="habilitaFiltro.secao">
            <v-autocomplete
              v-model="filtros.secao"
              :items="selects.secao.items"
              label="Selecione a seção"
              item-text="descricao_secao"
              item-value="idsecao"
              small-chips
              multiple
              outlined
              hide-details
              @change="verificaMultiplaSelecaoDeSecoes();"
              @blur="buscarSelectMenu(false, false, false, true);"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="habilitaFiltro.categoria">
            <v-autocomplete
              v-model="filtros.categoria"
              :items="selects.categoria.items"
              label="Selecione as categorias"
              item-text="descricao_categoria"
              item-value="idcategoria"
              small-chips
              multiple
              outlined
              hide-details
              @change="verificaMultiplaSelecaoDeCategorias();"
              @blur="buscarSelectMenu(false, false, false, false);"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="habilitaFiltro.ano">
            <v-select
              v-model="filtros.ano"
              :items="selects.ano.items"
              label="Selecione um ano"
              item-value="ano"
              item-text="ano"
              height="10"
              outlined
              chips
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="6" v-if="habilitaFiltro.dataIni">
            <v-text-field
              v-model="filtros.dataIni"
              label="Data Inicial*"
              height="10"
              type="date"
              outlined
              chips
              :error-messages="dataIniErrors"
              hide-details
              @input="$v.filtros.dataIni.$touch()"
              @blur="$v.filtros.dataIni.$touch()"
            ></v-text-field>
          </v-col>
          <v-col cols="6" v-if="habilitaFiltro.dataFin">
            <v-text-field
              v-model="filtros.dataFin"
              label="Data Final*"
              height="10"
              type="date"
              outlined
              chips
              :error-messages="dataFinErrors"
              hide-details
              @input="$v.filtros.dataFin.$touch()"
              @blur="$v.filtros.dataFin.$touch()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" v-if="habilitaFiltro.periodo">
            <v-text-field
              v-model="filtros.periodo"
              label="Período*"
              height="10"
              type="date"
              outlined
              chips
              :error-messages="periodoErrors"
              hide-details
              @input="$v.filtros.periodo.$touch()"
              @blur="$v.filtros.periodo.$touch()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" v-if="habilitaFiltro.comprador">
            <v-select
              v-model="filtros.comprador"
              :items="selects.comprador.items"
              label="Selecione o Comprador"
              item-text="nome_completo"
              item-value="idcomprador"
              height="10"
              outlined
              chips
              @change="buscarFornecedores()"
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" v-if="habilitaFiltro.fornecedor">
            <v-autocomplete
              v-model="filtros.fornecedor"
              :items="selects.fornecedor.items"
              label="Selecione o Fornecedor"
              item-text="razao_social"
              item-value="idfornecedor"
              outlined
              chips
              height="10"
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="habilitaFiltro.marca">
            <v-autocomplete
              v-model="filtros.marca"
              :items="selects.marca.items"
              label="Selecione a Marca"
              item-text="descricao_marca"
              item-value="idmarca"
              chips
              height="10"
              outlined
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" v-if="habilitaFiltro.segmento">
            <v-autocomplete
              v-model="filtros.segmento"
              :items="selects.segmento.items"
              label="Selecione o Segmento"
              item-text="descricao_departamento"
              item-value="iddepartamento"
              height="10"
              chips
              outlined
              clearable
              hide-details
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" v-if="habilitaFiltro.pqr">
            <v-select
              v-model="filtros.abc"
              :items="selects.abc.items"
              label="Selecione Classe ABC"
              item-text="abc"
              item-value="abc"
              hide-details
              height="10"
              outlined
              multiple
              clearable
              class="mb-8"
            >
              <template v-slot:selection="{ item }">
                <v-chip>
                  <span>{{ item.abc }}</span>
                </v-chip>
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @click="toggleAbc">
                  <v-list-item-action>
                    <v-icon v-if="filtros.abc.length > 0">mdi-close-box</v-icon>
                    <v-icon v-else color="indigo"
                    >mdi-checkbox-multiple-marked</v-icon
                    >
                  </v-list-item-action>
                  <v-list-item-content>
                    <span v-if="filtros.abc.length > 0">Remover Todos</span>
                    <span v-else>Selecionar Todos</span>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-col>

          <v-col cols="6" v-if="habilitaFiltro.pqr">
            <v-select
              v-model="filtros.pqr"
              :items="selects.pqr.items"
              label="Selecione Classe PQR"
              item-text="descricao"
              item-value="pqr"
              hide-details
              height="10"
              outlined
              multiple
              clearable
            >
              <template v-slot:selection="{ item }">
                <v-chip>
                  <span>{{ item.pqr }}</span>
                </v-chip>
              </template>
              <template v-slot:prepend-item>
                <v-list-item ripple @click="togglePqr">
                  <v-list-item-action>
                    <v-icon v-if="filtros.pqr.length > 0">mdi-close-box</v-icon>
                    <v-icon v-else color="indigo"
                    >mdi-checkbox-multiple-marked</v-icon
                    >
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span v-if="filtros.pqr.length > 0">Remover Todos</span>
                      <span v-else>Selecionar Todos</span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>
            </v-select>
          </v-col>
          <v-col
            cols="12"
            v-if="habilitaFiltro.saldoVendaEstoque"
            style="margin-top: -35px"
          >
            <v-checkbox
              v-model="filtros.saldoVendaEstoque"
              label="Processar os saldos  de venda e estoque  semestral"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            v-if="habilitaFiltro.tipoR"
            class="mb-n6 mt-n1"
          >
            <v-radio-group
              v-model="filtros.tipoR"
              row
              v-if="!filtros.saldoVendaEstoque"
            >
              <v-radio label="PDF" value="pdf"></v-radio>
              <v-radio label="Excel" value="excel"></v-radio>
            </v-radio-group>
          </v-col>

          <v-col
            cols="12"
            v-if="habilitaFiltro.tipoAnaliseRelatorioVendas"
            class="mb-n6 mt-n1"
          >
            <v-radio-group v-model="filtros.tipoAnalise" row>
              <v-radio label="Análise Anual" value="anual"></v-radio>
              <v-radio label="Análise Mensal" value="mensal"></v-radio>
            </v-radio-group>
          </v-col>

          <div
            v-if="relatorio.url === 'analise_movimentacao_produtos'"
            class="ml-1 mb-n9 mt-1"
          >
            <v-radio-group v-model="filtros.sem_movimentacao">
              <v-radio label="Sem Movimentação" :value="true"></v-radio>

              <div id="com-movimentacao">
                <v-radio class="mt-1_5" :value="false"></v-radio>
                <span>Sem movimentação nos últimos</span>
                <v-text-field
                  v-model="filtros.diasMovimentacao"
                  outlined
                  dense
                  style="width: 100px"
                  class="mt-6 ml-1"
                  type="number"
                  :disabled="filtros.sem_movimentacao"
                  @keyup="
                    filtros.diasMovimentacao = parseInt(
                      filtros.diasMovimentacao
                    )
                  "
                ></v-text-field>
                <span>&nbsp;dias</span>
              </div>
            </v-radio-group>
          </div>
        </v-row>
      </v-card-text>
      <v-card-actions class="mt-0">
        <v-spacer></v-spacer>
<!--        <v-btn color="white" @click="fecharDialog()">Fechar</v-btn>-->
        <v-btn
          color="primary"
          text
          @click="gerarRelatorio()"
          :disabled="!filtros.diasMovimentacao ? true : false"
        >Gerar Relatório</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import DrpAPI from "./../../api/drp";
import RelatorioAPI from "./../../api/relatorio";
import { getDepartamentos, getFornecedores, getSecoes, getCategorias } from "./../../api/relatorio";
import FornecedorAPI from "./../../api/fornecedor";
import $axios from './../../api/api.js'
import SysProdutoAutocomplete from './../utils/crud/SysProdutoAutocomplete.vue'
import SysUsuariosAutocomplete from "../utils/crud/SysUsuariosAutocomplete";
import SysFilialGrupoAutocomplete from "../utils/crud/SysFilialGrupoAutocomplete.vue";

export default {
  components: {
    SysUsuariosAutocomplete,
    SysProdutoAutocomplete,
    SysFilialGrupoAutocomplete
  },
  props: ["cont", "relatorio", "idproduto"],
  data: () => ({
    dialog: false,
    reset_menu: null,
    filtros: {
      grupo: 0,
      filial: 0,
      fornecedor: 0,
      comprador: 0,
      segmento: 0,
      departamento: [0],
      secao: [0],
      categoria: [0],
      ano: "",
      dataIni: "",
      dataFin: "",
      periodo: "",
      saldoVendaEstoque: false,
      pqr: [],
      abc: [],
      tipoR: "excel",
      tipoAnalise: "anual",
      sem_movimentacao: true,
      diasMovimentacao: 180,
      idproduto: "",
      usuarios: []
    },

    habilitaFiltro: {
      grupo: false,
      filial: false,
      fornecedor: false,
      comprador: false,
      segmento: false,
      ano: false,
      dataIni: false,
      dataFin: false,
      periodo: false,
      saldoVendaEstoque: false,
      compradorMult: false,
      fornecedorMult: false,
      segmentoMult: false,
      marca: false,
      pqr: false,
      abc: false,
      tipoR: false,
      tipoAnaliseRelatorioVendas: false,
      produtos: false,
      usuario: false
    },

    selects: {
      grupo: {
        items: [],
      },
      filial: {
        items: [],
      },
      fornecedor: {
        items: [],
      },
      comprador: {
        items: [],
      },
      segmento: {
        items: [],
      },
      marca: {
        items: [],
      },
      departamento: {
        items: []
      },
      secao: {
        items: []
      },
      categoria: {
        items: []
      },
      ano: {
        items: [],
      },
      pqr: {
        items: [
          { pqr: "P", descricao: "P - ALTA FREQUENCIA" },
          { pqr: "Q", descricao: "Q - FREQUENCIA INTERMEDIARIA" },
          { pqr: "R", descricao: "R - BAIXA FREQUENCIA" },
        ],
      },
      abc: {
        items: [{ abc: "A" }, { abc: "B" }, { abc: "C" }],
      },
    },

    removeTracos: (data) => data.replace("-", "").replace("-", ""),
  }),

  validations: {
    filtros: {

      idproduto: {
        required () {
          if (this.habilitaFiltro.produtos) {
            return required(this.filtros.idproduto)
          }

          return true
        }
      },
      dataIni: {
        required() {
          if (this.habilitaFiltro.dataIni) {
            if (this.filtros.dataIni.length == 10) return true;
            else return false;
          } else {
            return true;
          }
        },
      },
      dataFin: {
        required() {
          if (this.habilitaFiltro.dataFin) {
            if (this.filtros.dataFin.length == 10) return true;
            else return false;
          } else {
            return true;
          }
        },
        periodoInvalido() {
          const A = this.removeTracos(this.filtros.dataIni);
          const B = this.removeTracos(this.filtros.dataFin);

          if (A > B) return false;
          else return true;
        },
      },
      periodo: {
        required() {
          if (this.habilitaFiltro.periodo) {
            if (this.filtros.periodo.length == 10) return true;
            else return false;
          } else {
            return true;
          }
        },
      },
    },
  },

  created() {
    this.buscarFornecedores();
    this.buscarSegmentos();
    this.buscarMarcas();
    this.buscarCompradoresProdutoFilial();
  },

  computed: {
    ...mapGetters({
      grupoCompras: "usuario/getGrupoCompras",
      grupos: "usuario/getGrupos",
    }),
    produtoErrors() {
      const errors = [];
      if (!this.$v.filtros.idproduto.$dirty) return errors;
      !this.$v.filtros.idproduto.required && errors.push("Campo Obrigatório.");
      return errors;
    },
    disabled () {
      return [null, undefined, 0].includes(this.filtros.grupo)
    },
    dataIniErrors() {
      const errors = [];
      if (this.habilitaFiltro.dataIni) {
        if (!this.$v.filtros.dataIni.$dirty) return errors;

        if (!this.filtros.dataIni) {
          errors.push("Campo Obrigatório.");
        }
      }

      return errors;
    },
    dataFinErrors() {
      const errors = [];

      if (this.habilitaFiltro.dataFin) {
        if (!this.$v.filtros.dataFin.$dirty) return errors;

        const A = this.removeTracos(this.filtros.dataIni);
        const B = this.removeTracos(this.filtros.dataFin);

        if (!this.filtros.dataFin) {
          errors.push("Campo Obrigatório.");
        } else if (A > B) {
          errors.push("Período Inválido.");
        }
      }
      return errors;
    },
    periodoErrors() {
      const errors = [];
      if (this.habilitaFiltro.periodo) {
        if (!this.$v.filtros.periodo.$dirty) return errors;

        if (!this.filtros.periodo) {
          errors.push("Campo Obrigatório.");
        }
      }

      return errors;
    },
    semMov() {
      return this.filtros.sem_movimentacao;
    },
    tituloRelatorio() {
      if (!this.relatorio || !this.relatorio.title) return '';
      if (this.relatorio.title.includes('Relatório')) {
        return this.relatorio.title;
      }
      return `Relatório ${this.relatorio.title}`;
    },
  },

  watch: {
    cont() {
      this.dialog = true;
      this.setGrupos();
      this.buscarDadosFiltrosRelatorio();
      this.defineFiltrosHabilitados();
      this.filtros.abc = [];
      this.filtros.pqr = [];
      this.togglePqr();
      this.toggleAbc();
    },
    semMov() {
      if (!this.semMov) this.filtros.diasMovimentacao = 180;
    },
  },

  methods: {
    verificaMultiplaSelecaoDeDepartamentos () {
      const ultimoSelecionado = this.filtros.departamento[this.filtros.departamento.length - 1];

      if (parseInt(ultimoSelecionado) === 0) {
        this.filtros.departamento = [0]
      } else {
        this.filtros.departamento = this.filtros.departamento.filter(item => parseInt(item) != 0)
      }
    },
    verificaMultiplaSelecaoDeSecoes () {
      const ultimoSelecionado = this.filtros.secao[this.filtros.secao.length - 1];

      if (parseInt(ultimoSelecionado) === 0) {
        this.filtros.secao = [0]
      } else {
        this.filtros.secao = this.filtros.secao.filter(item => parseInt(item) != 0)
      }
    },
    verificaMultiplaSelecaoDeCategorias () {
      const ultimoSelecionado = this.filtros.categoria[this.filtros.categoria.length - 1];

      if (parseInt(ultimoSelecionado) === 0) {
        this.filtros.categoria = [0]
      } else {
        this.filtros.categoria = this.filtros.categoria.filter(item => parseInt(item) != 0)
      }
    },
    verificaMultiplaSelecaoDeCompradores () {
      if (this.relatorio.url !== 'relatorio_produtos_silenciados') return

      const ultimoSelecionado = this.filtros.comprador[this.filtros.comprador.length - 1]

      if (parseInt(ultimoSelecionado) === 0) {
        this.filtros.comprador = [0]
      } else {
        this.filtros.comprador = this.filtros.comprador.filter(item => parseInt(item) != 0)
      }
    },
    verificaMultiplaSelecaoDeFornecedores () {
      const ultimoSelecionado = this.filtros.fornecedor[this.filtros.fornecedor.length - 1];

      const ZERO_FORNECEDOR = this.selects.fornecedor.items.filter((f) => f.idfornecedor === 0).length > 0;

      if (ZERO_FORNECEDOR) {
        this.filtros.fornecedor = parseInt(ultimoSelecionado) === 0 ? [0] : this.filtros.fornecedor.filter(item => parseInt(item) != 0);
      }
    },

    verificaMultiplaSelecaoDeSegmentos () {
      if (['relatorios/analise-departamentos-compra-por-categorias'].includes(this.relatorio.url)) {
        const ultimoSelecionado = this.filtros.segmento[this.filtros.segmento.length - 1];

        if (parseInt(ultimoSelecionado) === 0) {
          this.filtros.segmento = [0]
        } else {
          this.filtros.segmento = this.filtros.segmento.filter(item => parseInt(item) != 0)
        }
      } else if (this.relatorio.url !== 'relatorio_produtos_silenciados') {
        return
      }
    },

    buscarFornecedorPorSegmento() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = { segmentos: this.filtros.segmento };

      this.selects.fornecedor.items = [];

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getFornecedorPorSegmentos(headers, params)
          .then((response) => {
            const { token, fornecedores_por_segmento } = response.data;
            localStorage.setItem("token", token);

            this.selects.fornecedor.items.push({
              idfornecedor: 0,
              razao_social: "Todos",
            });

            fornecedores_por_segmento.forEach((fornecedores) => {
              fornecedores.razao_social = fornecedores.idfornecedor + " - " + fornecedores.razao_social;
              this.selects.fornecedor.items.push(fornecedores);
            });
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    togglePqr() {
      this.$nextTick(() => {
        if (this.filtros.pqr.length > 0) {
          this.filtros.pqr = [];
        } else {
          this.selects.pqr.items.forEach((item) => {
            this.filtros.pqr.push(item.pqr);
          });
        }
      });
    },

    toggleAbc() {
      this.$nextTick(() => {
        if (this.filtros.abc.length > 0) {
          this.filtros.abc = [];
        } else {
          this.selects.abc.items.forEach((item) => {
            this.filtros.abc.push(item.abc);
          });
        }
      });
    },

    defineFiltrosHabilitados() {
      switch (this.relatorio.url) {
        case "relatorios/estoque-lojas":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.segmentoMult = true;
          this.habilitaFiltro.compradorMult = true;
          this.habilitaFiltro.fornecedorMult = true;
          break;
        case "relatorio_percepcao_compras":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.dataIni = true;
          this.habilitaFiltro.dataFin = true;
          this.habilitaFiltro.compradorMult = true;
          this.habilitaFiltro.tipoR = true;
          break;
        case "relatorio_analise_de_compras":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.comprador = true;
          this.habilitaFiltro.fornecedor = true;
          break;
        case "relatorio_oportunidade_venda":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.ano = true;
          this.habilitaFiltro.tipoR = true;
          break;
        case "relatorio_curva_abc":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.fornecedor = true;
          this.habilitaFiltro.segmento = true;
          this.habilitaFiltro.saldoVendaEstoque = true;
          this.habilitaFiltro.pqr = true;
          this.habilitaFiltro.abc = true;
          break;
        case "relatorio_de_ruptura":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.comprador = true;
          this.habilitaFiltro.fornecedor = true;
          break;
        case "relatorio_frequencia_saida":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filiais = true;
          this.habilitaFiltro.fornecedor = true;
          break;
        case "relatorio_itens_em_ponto_pedido":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.comprador = true;
          this.habilitaFiltro.fornecedor = true;
          break;
        case "relatorio_pedidos_qtde_diferente_sugestao":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.dataIni = true;
          this.habilitaFiltro.dataFin = true;
          break;
        case "relatorio_compras_dias_gatilho":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          break;
        case "comprador_fornecedores":
          this.habilitaFiltro.comprador = true;
          this.habilitaFiltro.tipoR = true;
          break;
        case "relatorio_compras_analise_obsolescencia":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          break;
        case "relatorio_ruptura_intralogistica":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.fornecedor = true;
          break;
        case "relatorio_compras_lotes_validades_produtos":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          break;
        case "relatorio_pedidos_pendentes_agro_boi":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.fornecedorMult = true;
          this.habilitaFiltro.comprador = true;
          break;
        case "relatorio_vendas_periodo":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.fornecedor = true;
          this.habilitaFiltro.dataIni = true;
          this.habilitaFiltro.dataFin = true;
          this.habilitaFiltro.tipoAnaliseRelatorioVendas = true;
          break;
        case "relatorio_vendas_periodo_quantitativo":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.fornecedor = true;
          this.habilitaFiltro.dataIni = true;
          this.habilitaFiltro.dataFin = true;
          this.habilitaFiltro.tipoAnaliseRelatorioVendas = true;
          break;
        case "relatorio_compras_periodo":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.fornecedor = true;
          this.habilitaFiltro.dataIni = true;
          this.habilitaFiltro.dataFin = true;
          this.habilitaFiltro.tipoAnaliseRelatorioVendas = true;
          break;
        case "relatorio_otif":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.departamento = true;
          this.habilitaFiltro.fornecedorMult = true;
          this.habilitaFiltro.compradorMult = true;
          this.habilitaFiltro.periodo = true;
          break;
        case "relatorio_ruptura_geral":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.fornecedor = true;
          this.habilitaFiltro.comprador = true;
          break;
        case "analise_movimentacao_produtos":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.departamento = true;
          this.habilitaFiltro.fornecedor = true;
          this.habilitaFiltro.marca = true;
          this.habilitaFiltro.comprador = true;
          break;
        case "relatorio_sugestao_itens_para_inativacao":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.fornecedor = true;
          this.habilitaFiltro.comprador = true;
          break;
        case "relatorio_itens_sem_pedido":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.fornecedor = true;
          break;
        case "relatorio_analise_geral_de_vendas":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.fornecedor = true;
          this.habilitaFiltro.dataIni = true;
          this.habilitaFiltro.dataFin = true;
          break;
        case "relatorio_produtos_silenciados":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.compradorMult = true;
          this.habilitaFiltro.fornecedorMult = true;
          this.habilitaFiltro.tipoR = false;
          break;
        case "relatorio_saldos_diario_de_produto":
          this.habilitaFiltro.produtos = true;
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.dataIni = true;
          this.habilitaFiltro.dataFin = true;
          break;
        case "relatorio_mix_mensal_produto":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          this.habilitaFiltro.fornecedorMult = true;
          this.habilitaFiltro.dataIni = true;
          this.habilitaFiltro.dataFin = true;
          break;
        case "relatorio_geral_produtos":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.filial = true;
          break;
        case "relatorios/analise-departamentos-compra-por-categorias":
          this.habilitaFiltro.grupo = true;
          this.habilitaFiltro.fornecedorMult = true;
          this.habilitaFiltro.departamento = true;
          this.habilitaFiltro.categoria = true;
          this.habilitaFiltro.secao = true;
          break;
        case "relatorio_estoque_estetico":
          this.habilitaFiltro.grupo = true
          this.habilitaFiltro.filial = true
          this.habilitaFiltro.segmentoMult = true
          this.habilitaFiltro.fornecedorMult = true
          break;
        case "relatorio_sazonalidade":
          this.habilitaFiltro.grupo = true
          this.habilitaFiltro.filial = true
          this.habilitaFiltro.segmentoMult = true
          this.habilitaFiltro.fornecedorMult = true
          this.habilitaFiltro.dataIni = true;
          this.habilitaFiltro.dataFin = true;
        break;
        case "relatorio_nivel_estoque":
          this.habilitaFiltro.grupo = true
          this.habilitaFiltro.filial = true
          this.habilitaFiltro.segmentoMult = true
          this.habilitaFiltro.fornecedorMult = true
          break;

        default:
          this.desabilitaTodosFiltros();
      }
    },
    buscarSelectMenu(departamento = false, fornecedor = false, secao = false, categoria = false) {
      clearTimeout(this.reset_menu);

      this.reset_menu = setTimeout(() => {
        if (departamento) this.buscarDepartamentosSelectMenu();
        if (fornecedor) this.buscarFornecedoresSelectMenu();
        if (secao) this.buscarSecoesSelectMenu();
        if (categoria) this.buscarCategoriasSelectMenu();
      }, 100);
    },
    buscarDepartamentosSelectMenu() {
      getDepartamentos(this.filtros)
        .then(departamentos => {
          this.selects.departamento.items = [];

          this.selects.departamento.items.push({
            iddepartamento: 0,
            descricao_departamento: "Todos",
          });

          departamentos.forEach((item) => {
            this.selects.departamento.items.push({
              iddepartamento: item.iddepartamento,
              descricao_departamento: item.iddepartamento + " - " + item.descricao_departamento
            });
          });

          this.filtros.departamento = [0];
        });
    },
    buscarFornecedoresSelectMenu() {
      getFornecedores(this.filtros)
        .then((fornecedores) => {
          this.selects.fornecedor.items = [];

          this.selects.fornecedor.items.push({
            idfornecedor: 0,
            razao_social: "Todos",
          });

          fornecedores.forEach((item) => {
            this.selects.fornecedor.items.push({
              idfornecedor: item.idfornecedor,
              razao_social: item.idfornecedor + " - " + item.razao_social
            });
          });
        })
        .finally(() => this.filtros.fornecedor = [0]);
    },
    buscarSecoesSelectMenu() {
      this.$store.dispatch(
        "loading/addRequisicao",
        getSecoes(this.filtros)
          .then(secoes => {
            this.selects.secao.items = [];

            this.selects.secao.items.push({
              idsecao: 0,
              descricao_secao: "Todos",
            });

            secoes.forEach((item) => {
              this.selects.secao.items.push({
                idsecao: item.idsecao,
                descricao_secao: item.idsecao + " - " + item.descricao_secao
              });
            });

            this.filtros.secao = [0];
          }));
    },
    buscarCategoriasSelectMenu() {
      this.$store.dispatch(
        "loading/addRequisicao",
        getCategorias(this.filtros)
          .then(categorias => {
            this.selects.categoria.items = [];

            this.selects.categoria.items.push({
              idcategoria: 0,
              descricao_categoria: "Todos",
            });

            categorias.forEach((item) => {
              this.selects.categoria.items.push({
                idcategoria: item.idcategoria,
                descricao_categoria: item.idcategoria + " - " + item.descricao_categoria
              });
            });

            this.filtros.categoria = [0];
          })
      );
    },
    buscarDadosFiltrosRelatorio() {
      if (["relatorios/analise-departamentos-compra-por-categorias"].includes(this.relatorio.url)) {
        this.buscarSelectMenu(true, true, true, true);
      } else if (this.relatorio.url == "relatorio_percepcao_compras") {
        this.getDataInicialFinal();
        this.buscarCompradoresPercepcaoCompras();
      } else if (
        this.relatorio.url === "relatorio_de_ruptura" ||
        this.relatorio.url === "relatorio_analise_de_compras" ||
        this.relatorio.url === "relatorio_itens_em_ponto_pedido" ||
        this.relatorio.url === "relatorio_ruptura_geral" ||
        this.relatorio.url === "relatorio_pedidos_pendentes_agro_boi" ||
        this.relatorio.url === "analise_movimentacao_produtos" ||
        this.relatorio.url === "relatorio_produtos_silenciados" ||
        this.relatorio.url === "relatorio_otif" ||
        this.relatorio.url === "relatorios/estoque-lojas" ||
        this.relatorio.url === "relatorios/sugestao-compras"
      ) {
        this.buscarSelectMenu(true, false, false, false);
        this.buscarFornecedores();
        this.buscarCompradoresProdutoFilial();
      } else if (
        this.relatorio.url === "relatorio_curva_abc" ||
        this.relatorio.url === "relatorio_vendas_periodo" ||
        this.relatorio.url === "relatorio_vendas_periodo_quantitativo" ||
        this.relatorio.url === "relatorio_compras_periodo" ||
        this.relatorio.url === "relatorio_frequencia_saida"
      ) {
        this.buscarFornecedores();

        if (
          this.relatorio.url === "relatorio_curva_abc"
        ) {
          this.buscarSegmentos();
        }
      } else if (this.relatorio.url === "relatorio_produtos_silenciados") {
        this.buscarCompradoresProdutoFilial();
        this.buscarFornecedoresProdutosSilenciados();
      } else if (this.relatorio.url === "relatorio_oportunidade_venda") {
        this.getAnos();
      } else if (this.relatorio.url === "comprador_fornecedores") {
        this.buscarCompradoresProdutoFilial();
      } else if (
        this.relatorio.url === "relatorio_sugestao_itens_para_inativacao"
      ) {
        this.buscarCompradoresProdutoFilial();
      }
    },

    buscarSegmentos() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getSegmentos(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.selects.segmento.items.push({
                iddepartamento: 0,
                descricao_departamento: "Todos",
              });

              response.data.segmentos.forEach((item) => {
                this.selects.segmento.items.push({
                  iddepartamento: item.iddepartamento,
                  descricao_departamento:
                    item.iddepartamento + " - " + item.descricao_departamento,
                });
              });

              this.filtros.segmento = [0];
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarMarcas() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getMarcas(headers)
        .then((response) => {
          const token = response.data.token;
          localStorage.setItem("token", token);

          if (response.status == 200) {
            this.selects.marca.items.push({
              idmarca: -1,
              descricao_marca: "Todos",
            });

            response.data.marcas.forEach((item) => {
              this.selects.marca.items.push({
                idmarca: item.idmarca,
                descricao_marca: item.descricao_marca,
              });
            });
          }
        })
        .catch(() => {
          this.Helpers.logout();
        })
        .finally(() => this.filtros.marca = -1)
      );
    },

    desabilitaTodosFiltros() {
      Object.keys(this.habilitaFiltro).forEach(filtro =>{
        this.habilitaFiltro[filtro] = false
      })
    },

    fecharDialog() {
      this.$v.$reset();
      this.dialog = false;
      this.defaultFiltros();
      this.desabilitaTodosFiltros();
    },

    defaultFiltros() {
      this.filtros.grupo = 0;
      this.filtros.filial = 0;
      this.filtros.grupo = 0;
      this.filtros.categoria = [];
      this.filtros.secao = [];
      this.filtros.fornecedor = [];
      this.filtros.comprador = 0;
      this.filtros.segmento = 0;
      this.filtros.ano = "";
      this.filtros.dataIni = "";
      this.filtros.dataFin = "";
      this.filtros.periodo = "";
      this.filtros.saldoVendaEstoque = false;
      this.filtros.tipoR = "excel";
      this.filtros.tipoAnalise = "anual";
      this.filtros.sem_movimentacao = true;
      this.filtros.diasMovimentacao = 180;
      this.filtros.usuarios = [];
    },

    buscarCompradoresProdutoFilial() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = { grupo: this.grupoCompras };

      this.selects.comprador.items = [];

      this.$store.dispatch(
        "loading/addRequisicao",
        RelatorioAPI.getCompradoresEmProdutosFilial(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.data.compradores.length > 0) {
              if (
                this.relatorio.url === "relatorio_analise_de_compras" ||
                this.relatorio.url === "relatorio_de_ruptura" ||
                this.relatorio.url === "relatorio_itens_em_ponto_pedido" ||
                this.relatorio.url === "relatorio_ruptura_geral" ||
                this.relatorio.url === "relatorio_pedidos_pendentes_agro_boi" ||
                this.relatorio.url === "analise_movimentacao_produtos" ||
                this.relatorio.url === "relatorio_sugestao_itens_para_inativacao" ||
                this.relatorio.url === "relatorio_produtos_silenciados" ||
                this.relatorio.url === "relatorio_otif" ||
                this.relatorio.url === "relatorios/estoque-lojas" ||
                this.relatorio.url === "relatorios/sugestao-compras"
              ) {
                this.selects.comprador.items.unshift({
                  idcomprador: 0,
                  nome_completo: "Todos",
                });
              }

              response.data.compradores.forEach((item) => {
                item.nome_completo = item.idcomprador + ' - ' + item.nome_completo;
                this.selects.comprador.items.push(item);
              });

              if (this.selects.comprador.items[0]) {
                this.filtros.comprador = this.selects.comprador.items[0].idcomprador;
              }
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarCompradoresPercepcaoCompras() {
      if (this.relatorio.url === "relatorio_percepcao_compras") {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          grupo: this.filtros.grupo ? this.filtros.grupo : this.grupoCompras,
        };

        this.selects.comprador.items = [];

        this.$store.dispatch(
          "loading/addRequisicao",
          RelatorioAPI.getCompradoresEmPercepcaoCompras(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.data.compradores.length > 0) {
                this.selects.comprador.items.push({
                  idcomprador: 0,
                  nome_completo: "Todos",
                });

                response.data.compradores.forEach((item) => {
                  this.selects.comprador.items.push(item);
                });

                this.filtros.comprador =
                  this.selects.comprador.items[0].idcomprador;
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    buscarFornecedoresProdutosSilenciados() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        grupo: this.filtros.grupo
      };

      this.selects.fornecedor.items = [];

      this.$store.dispatch(
        "loading/addRequisicao",
        FornecedorAPI.getFornecedoresProdutosSilenciados(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            const forns = response.data.fornecedores;

            let objForn = {
              idfornecedor: 0,
              razao_social: "Todos",
            };

            this.selects.fornecedor.items.push(objForn);

            forns.forEach((f) => {
              f.razao_social = f.idfornecedor + " - " + f.razao_social;
              this.selects.fornecedor.items.push(f);
            });

            this.filtros.fornecedor = 0;
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    buscarFornecedores() {
      this.selects.fornecedor.items = [];

      if (
        this.selects.fornecedor.items.length == 0 ||
        this.relatorio === "relatorio_analise_de_compras" ||
        this.relatorio.url === "relatorio_produtos_silenciados"
      ) {
        const headers = this.Helpers.iniciarRequisicao();

        let nome_completo = "";

        if (
          this.relatorio === "relatorio_analise_de_compras" &&
          this.selects.compradores.value != ""
        ) {
          let comprador = (c) => c.idcomprador == this.filtros.comprador;

          nome_completo =
            this.selects.compradores.items.filter(comprador)[0].nome_completo;
        }

        const params = {
          grupo: this.filtros.grupo,
          comprador: nome_completo
        };

        this.$store.dispatch(
          "loading/addRequisicao",
          DrpAPI.getFornecedores(headers, params)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              this.selects.fornecedor.items.push({
                idfornecedor: 0,
                razao_social: "Todos",
              });

              response.data.fornecedores.forEach((f) => {
                f.razao_social = f.idfornecedor + " - " + f.razao_social;
                this.selects.fornecedor.items.push(f);
              });
            })
            .catch(() => {
              this.Helpers.logout();
            })
            .finally(() => this.filtros.fornecedor = 0)
        );
      }
    },

    setGrupos() {
      this.selects.grupo.items = [];

      this.setGrupoTodos();

      this.grupos.forEach((grupo) => {
        this.selects.grupo.items.push(grupo);
      });

      this.filtros.grupo = this.grupoCompras;

      this.buscarFiliais();
    },

    setGrupoTodos() {
      if (
        this.relatorio.url != "relatorio_curva_abc" &&
        this.relatorio.url != "relatorio_percepcao_compras" &&
        this.relatorio.url != "relatorio_frequencia_saida" &&
        this.relatorio.url != "relatorio_compras_analise_obsolescencia" &&
        this.relatorio.url != "relatorio_ruptura_geral" &&
        this.relatorio.url != "analise_movimentacao_produtos" &&
        this.relatorio.url != "relatorio_vendas_periodo" &&
        this.relatorio.url != "relatorio_vendas_periodo_quantitativo" &&
        this.relatorio.url != "relatorio_compras_periodo" &&
        this.relatorio.url != "relatorio_analise_geral_de_vendas" &&
        this.relatorio.url != "relatorio_geral_produtos" &&
        this.relatorio.url != "relatorio_de_ruptura" &&
        this.relatorio.url != "relatorios/analise-departamentos-compra-por-categorias" &&
        this.relatorio.url != "relatorio_estoque_estetico" &&
        this.relatorio.url != "relatorio_sazonalidade" &&
        this.relatorio.url != "relatorio_nivel_estoque"
      ) {
        const grupoTodos = {
          id: 0,
          descricao: "Todos",
        };

        this.selects.grupo.items.push(grupoTodos);
      }
    },

    buscarFiliais() {
      if (
        this.filtros.grupo != 0 &&
        this.relatorio.url != "relatorio_pedidos_qtde_diferente_sugestao"
      ) {
        const headers = this.Helpers.iniciarRequisicao();

        const params = {
          grupo: this.filtros.grupo,
        };

        this.filtros.filial = "";
        this.selects.filial.items = [];

        DrpAPI.getFiliaisDrp(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (this.relatorio.url !== "analise_movimentacao_produtos") {
              let objFilial = { filial: 0, descricao: "Todas" };
              this.selects.filial.items.push(objFilial);
            }

            const filiais = response.data.filiais;

            filiais.forEach((filial) => {
              this.selects.filial.items.push(filial);
            });

            const naoSelecioneTodos = [
              "relatorio_curva_abc",
              "relatorio_frequencia_saida",
              "analise_movimentacao_produtos",
            ];

            if (!naoSelecioneTodos.includes(this.relatorio.url)) {
              this.filtros.filial = 0;
            } else {
              this.filtros.filial = this.selects.filial.items[0].filial;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          });
      } else {
        this.selects.filial.items = [{ filial: 0, descricao: "Todas" }];
      }
    },

    getAnos() {
      if (this.selects.ano.items.length == 0) {
        const headers = this.Helpers.iniciarRequisicao();

        this.$store.dispatch(
          "loading/addRequisicao",
          DrpAPI.getAnosRelatorio(headers)
            .then((response) => {
              const token = response.data.token;
              localStorage.setItem("token", token);

              if (response.status == 200) {
                this.selects.ano.items = response.data.anos;

                this.filtros.ano = this.selects.ano.items[0].ano;
              }
            })
            .catch(() => {
              this.Helpers.logout();
            })
        );
      }
    },

    getDataInicialFinal() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        DrpAPI.getDataInicialFinal(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.filtros.dataIni = response.data.dataIni;
              this.filtros.dataFin = response.data.dataFin;
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    gerarRelatorio() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        let url = this.relatorio.url + "?";

        Object.keys(this.filtros).forEach((valor) => {
          if (
            this.filtros[valor] > 0 ||
            this.filtros[valor].length > 0 ||
            valor == "tipoR" ||
            valor == "saldoVendaEstoque"
          ) {
            let isArray = Array.isArray(this.filtros[valor]);

            url = url
              .concat(valor)
              .concat(isArray && valor == "comprador" ? "[]" : "")
              .concat("=")
              .concat(this.filtros[valor])
              .concat("&");
          }
        });

        url = url
          .concat("usuario")
          .concat("=")
          .concat(localStorage.getItem("nome"));

        this.fecharDialog();

        window.open($axios.defaults.baseURL + "/" + url, "_blank");
      }
    },
  },
};
</script>

<style scoped>
#com-movimentacao {
  display: flex;
  align-items: center;
  margin-top: -20px;
  color: #555555;
}
.-mt-35 {
  margin-top: -35px;
}
.mt-1_5 {
  margin-top: 5px;
}
</style>
